import { render, staticRenderFns } from "./DeltaLegend.vue?vue&type=template&id=3242e5f4&scoped=true&"
import script from "./DeltaLegend.vue?vue&type=script&lang=ts&"
export * from "./DeltaLegend.vue?vue&type=script&lang=ts&"
import style0 from "./DeltaLegend.vue?vue&type=style&index=0&id=3242e5f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3242e5f4",
  null
  
)

export default component.exports